export const getGoogleApiKey = async (token) => {
	const url = new URL(`${process.env.REACT_APP_PORT}/env/getGoogleEnvInfo`);
	const response = await fetch(url, {
		method: "GET",
		headers: {
			"Content-Type": "application/json",
			Authorization: `Bearer ${token}`,
		},
	});

	const data = await response.json();
	if (data) return data.key;
	else return false;
};
